import { ImSpinner2 } from "react-icons/im";

export default function Loader() {
    return <ImSpinner2 className="spinner" />;
}
